'use client';

import { c as _c } from "react/compiler-runtime";
import IconLeave from '@/components/assets/icon_leave.svg';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
type ControlBarExitIconButtonProps = {
  ariaLabel: string;
  buttonClassName?: string;
  className?: string;
  dataAction?: string;
  iconClassName?: string;
  onClick: () => void;
};

/**
 * The Exit icon button shared by the standalone Mobile Control Bar (`Full3dExitButton` leaves the
 * content) and the embedded Mobile Control Bar (leaves native fullscreen). Only the label and the
 * click action differ, so both look and respond the same.
 */
export default function ControlBarExitIconButton(t0) {
  const $ = _c(18);
  const {
    ariaLabel,
    buttonClassName,
    className,
    dataAction,
    iconClassName,
    onClick
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0
    };
    t2 = {
      opacity: 1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease: [0.4, 0, 0.2, 1]
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = className ?? "z-floating absolute right-5 bottom-4";
  let t5;
  if ($[3] !== buttonClassName) {
    t5 = cn("group flex cursor-pointer items-center justify-center rounded-3xl bg-black/40 px-4 py-2 backdrop-blur-sm transition-colors duration-200 hover:bg-black/55", buttonClassName);
    $[3] = buttonClassName;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== iconClassName) {
    t6 = cn("group-hover:text-vive-brand-50 text-vive-primary-20 size-6 shrink-0 transition-[opacity,color] duration-200 group-hover:opacity-90", iconClassName);
    $[5] = iconClassName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <IconLeave className={t6} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== ariaLabel || $[10] !== dataAction || $[11] !== onClick || $[12] !== t5 || $[13] !== t7) {
    t8 = <button type="button" data-action={dataAction} aria-label={ariaLabel} className={t5} onClick={onClick}>{t7}</button>;
    $[9] = ariaLabel;
    $[10] = dataAction;
    $[11] = onClick;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <motion.div initial={t1} animate={t2} transition={t3} className={t4}>{t8}</motion.div>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}